export function getLaunchState(): LaunchState {
  var target = new Date("December 5, 2019");
  var d = new Date();

  if (d < target) {
    return LaunchState.BEFORE;
  }
  if (d.getMonth() === target.getMonth() && d.getDate() == target.getDate()) {
    return LaunchState.CURRENT;
  }
  return LaunchState.AFTER;
}

export enum LaunchState {
  BEFORE = 0,
  CURRENT = 1,
  AFTER = 3
}
